import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import clsx from 'clsx';

export type HeroBackgroundProps = {
  className?: string;
};

export const HeroBackground: React.FC<HeroBackgroundProps> = ({ className }) => {
  const reduce = useReducedMotion();

  return (
    <div 
      aria-hidden="true" 
      className={clsx(
        'absolute inset-0 overflow-hidden pointer-events-none',
        'bg-slate-900',
        className
      )}
    >
      {/* GRID */}
      <div
        className="absolute inset-0 z-0 opacity-100"
        style={{
          // UPDATED: Increased opacity to 0.35 so white grid is clearly visible
          backgroundImage: `
            linear-gradient(to right, rgba(255, 255, 255, 0.35) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255, 255, 255, 0.35) 1px, transparent 1px)
          `,
          backgroundSize: '40px 40px',
          maskImage: 'radial-gradient(ellipse at center, black 40%, transparent 80%)',
        }}
      />

      {/* CENTER GLOW */}
      <div className="absolute top-[-20%] left-1/2 -translate-x-1/2 w-[90vw] h-[800px] z-0 pointer-events-none">
        <div className="absolute inset-0 rounded-full blur-[120px] bg-blue-600/20" />
      </div>

      {/* DATA LINES */}
      {!reduce && (
        <div className="absolute inset-0 z-0 opacity-20">
             <motion.div
                className="absolute top-0 w-[1px] bg-cyan-400"
                style={{ height: '20vh', left: '20%' }}
                initial={{ y: -200 }}
                animate={{ y: '120vh' }}
                transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
             />
             <motion.div
                className="absolute top-0 w-[1px] bg-cyan-400"
                style={{ height: '35vh', left: '80%' }}
                initial={{ y: -400 }}
                animate={{ y: '120vh' }}
                transition={{ duration: 6, repeat: Infinity, ease: "linear", delay: 2 }}
             />
        </div>
      )}
    </div>
  );
};